/*!
 * Copyright © 2020-2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { createAction, props } from '@ngrx/store';

import {
  IFailureProps,
  IRequestStatusProps,
  ISendVerificationCodeRequestProps,
  ISendVerificationCodeSuccessProps,
  ISetCredentialsRequestProps
} from '../../models';

export enum UserActionTypes {
  SendVerificationCodeRequest = '[User] SendVerificationCodeRequest',
  SendVerificationCodeSuccess = '[User] SendVerificationCodeSuccess',
  SendVerificationCodeFailure = '[User] SendVerificationCodeFailure',
  ResendVerificationCodeRequest = '[User] ResendVerificationCodeRequest',
  ResendVerificationCodeSuccess = '[User] ResendVerificationCodeSuccess',
  ResendVerificationCodeFailure = '[User] ResendVerificationCodeFailure',
  SetCredentialsRequest = '[User] SetCredentialsRequest',
  SetCredentialsSuccess = '[User] SetCredentialsSuccess',
  SetCredentialsFailure = '[User] SetCredentialsFailure',
  UpdateRequestStatus = '[User] UpdateRequestStatus',
  ResetAccountActivation = '[User] ResetAccountActivation'
}

export const SendVerificationCodeRequest = createAction(
  UserActionTypes.SendVerificationCodeRequest,
  props<ISendVerificationCodeRequestProps>()
);

export const SendVerificationCodeSuccess = createAction(
  UserActionTypes.SendVerificationCodeSuccess,
  props<ISendVerificationCodeSuccessProps>()
);

export const SendVerificationCodeFailure = createAction(UserActionTypes.SendVerificationCodeFailure, props<IFailureProps>());

export const ResendVerificationCodeRequest = createAction(UserActionTypes.ResendVerificationCodeRequest);

export const ResendVerificationCodeSuccess = createAction(
  UserActionTypes.ResendVerificationCodeSuccess,
  props<ISendVerificationCodeSuccessProps>()
);

export const ResendVerificationCodeFailure = createAction(UserActionTypes.ResendVerificationCodeFailure, props<IFailureProps>());

export const SetCredentialsRequest = createAction(UserActionTypes.SetCredentialsRequest, props<ISetCredentialsRequestProps>());

export const SetCredentialsSuccess = createAction(UserActionTypes.SetCredentialsSuccess);

export const SetCredentialsFailure = createAction(UserActionTypes.SetCredentialsFailure, props<IFailureProps>());

export const UpdateRequestStatus = createAction(UserActionTypes.UpdateRequestStatus, props<IRequestStatusProps>());

export const ResetAccountActivation = createAction(UserActionTypes.ResetAccountActivation);
